import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBetsAndPicks = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 29.6 29.6",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M19.2 6.2v-.9c0-.6-.5-1.1-1.1-1.1H7c-.6 0-1.1.5-1.1 1.1v15.5l2-1.2"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M23.7 25.3V9.8c0-.6-.5-1.1-1.1-1.1H11.5c-.6 0-1.1.5-1.1 1.1v15.5l3.8-2.2 2.9 2.2 2.9-2.2 3.8 2.2h0ZM14.1 12.5h6M14.1 15.9h3.1M14.1 19.2h5.4"
	})]
});
export { SvgIconBetsAndPicks as ReactComponent };
